import React, { useEffect } from 'react'
import { Field as FieldConf, getFieldLabel } from 'src/config'
import * as types from '../../../types'
import { InputLabel, OutlinedInput } from '@mui/material'

const SimpleTextField: React.FC<{
    field: FieldConf,
    value?: types.SimpleValue,
    onChange: (value: types.Value) => void,
    disabled?: boolean
    errors?: types.Error[],
    // options?: types.EntityOptions
    multiline?: boolean
}> = ({
    field,
    value,
    onChange,
    disabled = false,
    errors = [],
    // options
    multiline = false
}) => {
        const { name, label, description, required } = field;

        return (
            <>
                <InputLabel
                    htmlFor={'field-' + name}
                    sx={{ color: theme => required ? theme.palette.error.main : theme.palette.text.secondary }}
                >
                    {getFieldLabel(field)}
                </InputLabel>
                <OutlinedInput
                    id={'field-' + name}
                    value={value != null ? value.toString() : ''}
                    onChange={(e) => onChange(e.target.value)}
                    label={name}
                    disabled={disabled}
                    multiline={multiline}
                    rows={multiline ? 5 : undefined}
                    required={required}
                    error={errors.length > 0}
                />
            </>
        )
    }

export default SimpleTextField;